<!-- 🟦 Help + Search (fixed top) -->
<div class="dialog-help bg-gray-50 border-b border-gray-200 p-3 sticky top-0 z-10">
  <app-help-page [text]="help.helpColumnText"></app-help-page>

  <mat-form-field appearance="outline" class="search-field mt-2">
    <mat-icon matPrefix svgIcon="c:search"></mat-icon>
    <input
      matInput
      placeholder="Search columns..."
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearchChange()"
      />
    </mat-form-field>

    <div class="list-meta">
      <span>{{ filteredSelectedColumns.length }} of {{ filteredSelectedColumns.length + filteredUnselectedColumns.length }} selected</span>
      <span class="list-meta-actions">
        @if (filteredUnselectedColumns.length > 0) {
          <a tabindex="0" (click)="selectAll()" (keyup.enter)="selectAll()">Select all</a>
        }
        @if (filteredSelectedColumns.length > 0 && filteredUnselectedColumns.length > 0) {
          <span class="list-meta-dot">&middot;</span>
        }
        @if (filteredSelectedColumns.length > 0) {
          <a tabindex="0" (click)="clearAll()" (keyup.enter)="clearAll()">Clear</a>
        }
      </span>
    </div>
  </div>

  <!-- 🧾 Scrollable column content -->
  <mat-dialog-content class="dialog-content scrollable-content">
    <!-- 🟦 Selected Columns -->
    @if (filteredSelectedColumns.length>0) {
      <div class="selected-section">
        <cdk-drop-list (cdkDropListDropped)="drop($event)">
          @for (col of filteredSelectedColumns; track col) {
            <div
              cdkDrag
              class="column-item selected"
              >
              <mat-checkbox
                [checked]="col.selected"
                (change)="onToggleColumn($event, col)"
                >
                {{ col.headerText }}
              </mat-checkbox>
              <mat-icon class="c-icon-slate drag-icon" cdkDragHandle>drag_indicator</mat-icon>
            </div>
          }
        </cdk-drop-list>
      </div>
    }

    <!-- 🟨 Available Columns -->
    @for (col of filteredUnselectedColumns; track col) {
      <div
        class="column-item available"
        >
        <mat-checkbox
          [checked]="col.selected"
          (change)="onToggleColumn($event, col)"
          >
          {{ col.headerText }}
        </mat-checkbox>
      </div>
    }
  </mat-dialog-content>
  <!-- 🟫 Footer (sticky) -->
  <mat-dialog-actions class="dialog-footer">

    <div class="flex items-center gap-5">
      <button mat-stroked-button (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary" (click)="onDownload(false)">
        <mat-icon fontIcon="ios_share"></mat-icon> Export CSV
      </button>
      @if (hasSelectedColumns && hasChanges) {
        <button
          mat-raised-button
          color="secondary"
          (click)="onDownload(true)"
          >
          <mat-icon fontIcon="save_alt"></mat-icon> Save & Download
        </button>
      }
    </div>
  </mat-dialog-actions>